/**
 * Coarse "how long ago" for credential lists.
 *
 * Extracted from ActiveSessions.tsx when Connected apps became the second caller — the
 * project rule is that anything used in two places stops being local. Deliberately coarse and
 * deliberately not internationalised: it matches what was already shipping, and changing the
 * wording here changes it on the sessions card too.
 *
 * Takes an ISO string because that is what the API returns; `null` is a real value (a grant
 * that has never been refreshed has no `lastUsedAt`) and reads as "never".
 */
export const relativeTime = (iso: string | null): string => {
  if (!iso) return 'never';
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} h ago`;
  return `${Math.floor(hrs / 24)} d ago`;
};
